import type { IconNode } from '../types';

/**
 * @name coins-exchange
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNiAxMFY1YzAtMS43IDEuMy0zIDMtM2gxIiAvPgogIDxwYXRoIGQ9Im0zIDcgMyAzIDMtMyIgLz4KICA8Y2lyY2xlIGN4PSIxOCIgY3k9IjYiIHI9IjQiIC8+CiAgPHBhdGggZD0iTTE4IDE0djVjMCAxLjctMS4zIDMtMyAzaC0xIiAvPgogIDxwYXRoIGQ9Im0yMSAxNy0zLTMtMyAzIiAvPgogIDxjaXJjbGUgY3g9IjYiIGN5PSIxOCIgcj0iNCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/coins-exchange
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const coinsExchange: IconNode = [
  ['path', { d: 'M6 10V5c0-1.7 1.3-3 3-3h1', key: '13af7h' }],
  ['path', { d: 'm3 7 3 3 3-3', key: 'x25e72' }],
  ['circle', { cx: '18', cy: '6', r: '4', key: '14r987' }],
  ['path', { d: 'M18 14v5c0 1.7-1.3 3-3 3h-1', key: '1ogxox' }],
  ['path', { d: 'm21 17-3-3-3 3', key: '1m4qyr' }],
  ['circle', { cx: '6', cy: '18', r: '4', key: 'jn0mx' }],
];

export default coinsExchange;
